<template>
  <div class="main">
    <p>SCORE: {{ score }}</p>
    <canvas width="400" height="400" id="canvas_"></canvas>
    <button  @click="this.init" ref="startButton">START</button>

  </div>
</template>
<script>
import apiClientCreator from "../../../../helpers/api/request";
export default {
  name: "SnakeGame",
  data: function() {
    return {
      canvas: null,
      ctx: null,
      w: null,
      h: null,
      snake_array: [],
      cw: 10,
      d: null,
      food: null,
      score: 0,
      game_loop: null
    };
  },
  methods: {
    init: function() {
      this.d = "right"; //default direction
      this.create_snake();
      this.create_food(); //Now we can see the food particle
      //finally lets display the score
      this.score = 0;

      //Lets move the snake now using a timer which will trigger the paint function
      //every 60ms

      clearInterval(this.game_loop);
      this.game_loop = setInterval(this.paint, 100);
    },
    create_snake: function() {
      var length = 5; //Length of the snake
      this.snake_array = []; //Empty array to start with
      for (var i = length - 1; i >= 0; i--) {
        //This will create a horizontal snake starting from the top left
        this.snake_array.push({ x: i, y: 0 });
      }
    },

    create_food: function() {
      this.food = {
        x: Math.round((Math.random() * (this.w - this.cw)) / this.cw),
        y: Math.round((Math.random() * (this.h - this.cw)) / this.cw)
      };
    },

    paint: function() {
      //To avoid the snake trail we need to paint the BG on every frame
      //Lets paint the canvas now
      this.ctx.fillStyle = "white";
      this.ctx.fillRect(0, 0, this.w, this.h);
      this.ctx.strokeStyle = "black";
      this.ctx.strokeRect(0, 0, this.w, this.h);

      //The movement code for the snake to come here.
      //The logic is simple
      //Pop out the tail cell and place it infront of the head cell
      var nx = this.snake_array[0].x;
      var ny = this.snake_array[0].y;
      //These were the position of the head cell.
      //We will increment it to get the new head position
      //Lets add proper direction based movement now
      if (this.d == "right") nx++;
      else if (this.d == "left") nx--;
      else if (this.d == "up") ny--;
      else if (this.d == "down") ny++;

      //Lets add the game over clauses now
      //This will restart the game if the snake hits the wall
      //Lets add the code for body collision
      //Now if the head of the snake bumps into its body, the game will restart
      if (
        nx == -1 ||
        nx == this.w / this.cw ||
        ny == -1 ||
        ny == this.h / this.cw ||
        this.check_collision(nx, ny, this.snake_array)
      ) {
        // if game ended
        clearInterval(this.game_loop);
        this.$emit('game-over', this.score);
        apiClientCreator(`users/score`)
          .post("", { score: this.score, game: "Snake" })
          .catch(() => {});
        return;
      }

      //Lets write the code to make the snake eat the food
      //The logic is simple
      //If the new head position matches with that of the food,
      //Create a new head instead of moving the tail
      if (nx == this.food.x && ny == this.food.y) {
        var tail = { x: nx, y: ny };
        this.score++;
        this.$emit('score-update', this.score);

        //Create new food
        this.create_food();
      } else {
        var tail = this.snake_array.pop(); //pops out the last cell
        tail.x = nx;
        tail.y = ny;
      }
      //The snake can now eat the food.

      this.snake_array.unshift(tail); //puts back the tail as the first cell

      for (var i = 0; i < this.snake_array.length; i++) {
        var c = this.snake_array[i];
        //Lets paint 10px wide cells
        this.paint_cell(c.x, c.y, "blue");
      }

      //Lets paint the food
      this.paint_cell(this.food.x, this.food.y, "red");
      //Lets paint the score
    },

    paint_cell: function(x, y, color) {
      this.ctx.fillStyle = color;
      this.ctx.fillRect(x * this.cw, y * this.cw, this.cw, this.cw);
      this.ctx.strokeStyle = "white";
      this.ctx.strokeRect(x * this.cw, y * this.cw, this.cw, this.cw);
    },

    check_collision: function(x, y, array) {
      //This function will check if the provided x/y coordinates exist
      //in an array of cells or not
      for (var i = 0; i < array.length; i++) {
        if (array[i].x == x && array[i].y == y) return true;
      }
      return false;
    },

    KeyDownEvent: function(e) {
      let key = e.which;
      if (key == "37" && this.d != "right") this.d = "left";
      else if (key == "38" && this.d != "down") this.d = "up";
      else if (key == "39" && this.d != "left") this.d = "right";
      else if (key == "40" && this.d != "up") this.d = "down";
    }
  },

  mounted: function() {
    this.canvas = document.getElementById("canvas_");
    this.ctx = this.canvas.getContext("2d");
    this.w = this.canvas.width;
    this.h = this.canvas.height;
    document.addEventListener("keydown", this.KeyDownEvent);

    // this.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  text-align: center;
  font-family: Montserrat;
  height: fit-content;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100px !important;
  overflow: hidden;
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

button {
  margin: 5px auto;
  background: #44a2d2;
  color: white;
  border: 0;
  padding: 5px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
  display: block;
}

#canvas {
  border: 10px solid #657;
}


</style>
